var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { orderBy } from "lodash";
import { getPagedId as getPagedIdBase, } from "../../redux/generic/paged.utils";
import { EDocumentCategory } from "../../types/document.types";
import { ERegistrationDocumentStatus, ERegistrationDocumentType, } from "../../types/registration.types";
export var getPagedId = function (params) {
    return getPagedIdBase(__assign(__assign({}, params), { entityName: "rentRegistration" }));
};
export var getContractDocument = function (registration) {
    return registration.documents.find(function (document) { return document.documentType === ERegistrationDocumentType.Contract; });
};
export var getAddenda = function (registration) {
    return orderBy(registration.documents.filter(function (document) { return document.documentType === ERegistrationDocumentType.Addendum; }), "id");
};
export var getLocationDescription = function (registration) {
    return registration.documents.find(function (document) {
        return document.documentType ===
            ERegistrationDocumentType.PropertyInspectionReport;
    });
};
/**
 * The inspection-report slots a new report can still be sent for.
 *
 * Exported so the tests over `canRegisterInspectionReport` generate their cases
 * from this set rather than a copy of it. Changing it changes which leases the
 * signing wizard offers automatic registration to, so it is pinned directly in
 * `autoRegistration.utils.test.ts` - the derived cases alone would follow a
 * change instead of failing on it.
 */
export var RETRYABLE_INSPECTION_REPORT_STATUSES = [
    ERegistrationDocumentStatus.None,
    ERegistrationDocumentStatus.Rejected,
    ERegistrationDocumentStatus.Failed,
];
/**
 * Whether MyRent would take another inspection report for this registration.
 *
 * Any status outside the retryable set means MyRent already holds a report or
 * is working on one. This is the condition the registration drawer offers its
 * "add location description" action under
 * (Drawers/Registration/Registration.utils.tsx), minus the contract barcode
 * that action checks alongside it.
 *
 * The document's own status is the live row; `locationDescriptionStatus` is the
 * API's mapping of it and is the fallback for a registration whose documents
 * did not come back.
 */
export var canRegisterInspectionReport = function (registration) {
    var _a, _b;
    return RETRYABLE_INSPECTION_REPORT_STATUSES.includes((_b = (_a = getLocationDescription(registration)) === null || _a === void 0 ? void 0 : _a.status) !== null && _b !== void 0 ? _b : registration.locationDescriptionStatus);
};
export var getDocumentCategoryId = function (params) {
    var documentType = params.documentType;
    switch (documentType) {
        case ERegistrationDocumentType.Addendum:
            return EDocumentCategory.ContractAddendum;
        case ERegistrationDocumentType.Contract:
            return EDocumentCategory.Contract;
        case ERegistrationDocumentType.PropertyInspectionReport:
            return EDocumentCategory.LocationDescription;
        default:
            return EDocumentCategory.Other;
    }
};
